var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 50,
    viewBox: "0 0 60 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0304 0.513298C21.6988 0.244433 26.7762 4.07865 29.671 9.81029L30.1173 10.6939L30.5461 9.84498C30.7455 10.2296 30.9699 10.9775 31.1928 12.0789C31.6696 14.4346 32.0877 18.1192 32.368 22.3409C32.9291 30.7913 32.9308 41.2729 31.7899 47.389C31.5804 48.5104 31.1812 49.0374 30.7819 49.2778C30.3758 49.5224 29.8467 49.5456 29.218 49.3885C28.1641 49.1251 27.0939 48.4325 26.3961 47.9809C26.2422 47.8813 26.1064 47.7934 25.9929 47.7245L25.9929 47.7244C20.1959 44.2027 13.9133 39.3256 9.03424 33.5935C4.15159 27.8572 0.710159 21.3079 0.506853 14.4324L0.506853 14.4324C0.405641 11.0112 1.42348 7.61595 3.63158 5.04048C5.83243 2.47346 9.24921 0.681246 14.0304 0.513298ZM14.0304 0.513298L14.0129 0.013605L14.0304 0.513298Z",
    fill: "url(#paint0_linear_56_200)",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5524 9.83109L30.5524 9.83103L30.5525 9.83098L30.5582 9.82082L30.5635 9.81029C32.019 6.92855 33.9609 4.54226 36.4805 2.90887C38.9962 1.27801 42.1174 0.37826 45.9682 0.513297C50.7501 0.681246 54.1669 2.47347 56.3677 5.04033C58.5758 7.61561 59.5937 11.0105 59.4931 14.4311C59.2898 21.2975 55.8527 27.8456 50.9767 33.5833C46.1044 39.3167 39.8309 44.1978 34.0436 47.7207L34.0435 47.7208C31.572 49.2259 30.6105 49.6831 29.4431 49.4381C28.7165 49.1658 27.9867 48.2817 27.3374 46.7541C26.6935 45.2391 26.1816 43.2161 25.8205 40.9021C25.0988 36.2772 24.9934 30.5805 25.5819 25.6677C26.1175 21.1986 27.3615 17.2349 28.4736 14.3862C29.0293 12.9628 29.5511 11.8203 29.9331 11.0352C30.124 10.6427 30.28 10.3397 30.3876 10.1358C30.4415 10.0339 30.4832 9.95669 30.5112 9.9055L30.5427 9.84835L30.5504 9.83468L30.5521 9.83162L30.5524 9.83109Z",
    fill: "url(#paint1_linear_56_200)",
    stroke: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_56_200",
    x1: 2741.96,
    y1: 0,
    x2: 2741.96,
    y2: 2249.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF465D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_56_200",
    x1: 3062.05,
    y1: 362.025,
    x2: 2078.45,
    y2: 1998.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D46FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#391FAB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.88eba1d6e19160b0b74e16c07a5e8dde.svg";
export { ForwardRef as ReactComponent };